import { baseApi } from './baseApi';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReport: builder.query({
      query: ({ reportType, ...params }) => ({
        url: `/reports/${reportType}`,
        params,
      }),
      providesTags: (result, error, { reportType }) => [{ type: 'Report', id: reportType }],
    }),
  }),
});

export const { useGetReportQuery } = reportsApi;
